import { pipelineReducer as pipeline } from '../../features/pipeline/pipeline-slice.js';
import { setPipeline } from './pipeline-actions.js';
/**
 * Loads the `pipeline` reducer and returns possible action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category Pipeline
 */
export function loadPipelineActions(engine) {
    engine.addReducers({ pipeline });
    return {
        setPipeline,
    };
}
